
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { PlantStoreMixin } from "@/mixins/Stores/PlantStoreMixin";
import GrowTent from "@/components/svg/GrowTent.vue";
import PlantCharts from "@/components/modules/plant/PlantCharts.vue";

@Component({
  components: { PlantCharts, GrowTent },
})
export default class Default extends mixins(PlantStoreMixin) {}
